module.exports = __webpack_public_path__ + "assets/otherVerification.f58fb2de.svg";